module.exports = __webpack_public_path__ + "img/pic08.b43bea40.jpg";